import { getListOfSongs } from "../songHistory/getListOfSongs";
import { setSlideDimensions } from "./slidesOps/setSlideDimensions";
import { initSlides } from "./slidesOps/initSlides";
import { setupSlides } from "./slidesOps/setupSlides";
import { configureDatabase } from "./data/data";
import { getSlides } from "./slidesOps/getSlides";
import { watchTimers } from "./countdown";
import { insertSlideCountdownHTML } from "./countdown/insertSlideCountdownHTML";
import { initCurrentDate } from "../cpcoc/currentDate";
import { manageActivePages } from "./state/manageActivePages";
import "reveal.js/css/reveal.scss";
import "reveal.js/dist/theme/black.css";
import "./index.scss";
import { resetCSS } from "../cpcoc/resetCSS";
import { resetJS } from "../cpcoc/resetJS";
import { querySelectorURL } from "../cpcoc/querySelectorURL";
import { refreshListener } from "./refresh/refreshListener";
// Build a basic UI
//  - [ ] adding a meeting?
//  - [ ] slide creator would be sick
//  - [ ] put more in database
// TODO: livestream
// TODO: cleanup unused code
const awaitTimers = watchTimers(); // waiting for active service to get set..
initCurrentDate(querySelectorURL("mockDate"));
configureDatabase();
refreshListener();
setSlideDimensions();
// window.getSermons = getSermons;
window.addEventListener("load", () => {
    resetCSS(".launch-slides");
    resetJS(".launch-slides");
    setupSlides();
    insertSlideCountdownHTML();
    // TODO: is there a better way to handle this?
    awaitTimers.then(() => {
        manageActivePages();
        getSlides();
        initSlides().then(() => {
            // TODO: move to worker
            getListOfSongs(); // last item because not relative to running slides
            // getSermons();
        });
    });
});
